import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './styles.css';

import logo_sade_negro from '../../../images/logo_sade_negro.png';

const { Column } = Table;

const valuesPL01Position = { "M": 1, "R": 2, "B": 3, "MB": 4, "E": 5, "N/A": 6 }

const valuesPL02Position = { "M": 1, "R": 2, "B": 3, "MB": 4, "E": 5, "N/A": 6 }

const surveyNameFilters = [{text: "Encuesta SAT", value: "Encuesta SAT"}, {text: "Encuesta satisfaccion servicios de consultoria", value: "Encuesta satisfaccion servicios de consultoria"}, {text: "Encuesta satisfaccion servicios electromecanicos", value: "Encuesta satisfaccion servicios electromecanicos"}]

const SurveysSolvedTable = ({ data }) => {

    const onDownloadSurvey = survey => {
        switch (survey.surveyType) {
            case "PL01":
                downloadPL01(survey)
                break;
            case "PL02":
                downloadPL02(survey)
                break;
            case "PL03":
                downloadPL03(survey)
                break;
        }
    }

    const loadImage = url => {
        return new Promise((resolve) => {
          let img = new Image();
          img.onload = () => resolve(img);
          img.src = url;
        })
    }

    const downloadPL01 = survey => {
        loadImage(logo_sade_negro).then((logo) => {
            var doc = new jsPDF();
            var yPositionAmount = 0;
            doc.addImage(logo, 'PNG', 14, 8, 30, 14.43);
            //Date Solved
            doc.setFontSize(12)
            var textWidthDate = doc.getStringUnitWidth(`Fecha de realización: ${moment(survey.solvedDate, "HH:mm DD/MM/YYYY").format("DD/MM/YYYY")}`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDate = (doc.internal.pageSize.width - textWidthDate) - 14;
            yPositionAmount += 18
            doc.text(textOffsetDate, yPositionAmount, `Fecha de realización: ${moment(survey.solvedDate, "HH:mm DD/MM/YYYY").format("DD/MM/YYYY")}`);
            // title
            doc.setFontSize(18)
            var textWidthTitle = doc.getStringUnitWidth(`${survey.surveyName}`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitle = (doc.internal.pageSize.width - textWidthTitle) / 2;
            yPositionAmount += 10
            doc.text(textOffsetTitle, yPositionAmount, `${survey.surveyName}`);
            //REV. NUM
            doc.setFontSize(10)
            yPositionAmount += 6
            doc.text(`Número de revisión: 00`, 14, yPositionAmount)
            //FECHA VIGENCIA
            doc.setFontSize(10)
            var textWidthDateV = doc.getStringUnitWidth(`Fecha de vigencia: abril 2018`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDateV = (doc.internal.pageSize.width - textWidthDateV) / 2;
            doc.text(textOffsetDateV, yPositionAmount, `Fecha de vigencia: abril 2018`);
            //ID PL
            doc.setFontSize(10)
            var textWidthDate = doc.getStringUnitWidth(`PL01-PR-GGC-004`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDate = (doc.internal.pageSize.width - textWidthDate) - 14;
            doc.text(textOffsetDate, yPositionAmount, `PL01-PR-GGC-004`);
            //
            doc.setFontSize(14)
            doc.setFontType("bold");
            yPositionAmount += 12
            doc.text(`I- DEL PRESENTADOR:`, 14, yPositionAmount)
            doc.setFontSize(12)
            doc.setFontType("normal")
            yPositionAmount += 7
            doc.text(`Nombre de Empresa, Comuna o Cooperativa: ${survey.answers.PL01_provider_name}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Localidad: ${survey.answers.PL01_provider_location}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Dirección: ${survey.answers.PL01_provider_direction}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`e-mail: ${survey.answers.PL01_provider_email}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Actividad/Servicio: ${survey.answers.PL01_provider_activity_service}`, 14, yPositionAmount)
            var PL01Types = ""
            survey.answers.PL01_types.forEach((type, index) => {
                if(index < (survey.answers.PL01_types.length - 1)) {
                    PL01Types = `${PL01Types} ${type},`
                } else {
                    PL01Types = `${PL01Types} ${type}`
                }
            });
            yPositionAmount += 7
            doc.text(`Servicio Asistencia Técnica contratado:`, 14, yPositionAmount)
            yPositionAmount += 6
            doc.text(`${PL01Types}`, 18, yPositionAmount)
            //
            doc.setFontSize(14)
            doc.setFontType("bold");
            yPositionAmount += 12
            doc.text(`II- DEL ENCUESTADO:`, 14, yPositionAmount)
            doc.setFontSize(12)
            doc.setFontType("normal")
            yPositionAmount += 7
            doc.text(`Apellido y Nombre: ${survey.answers.PL01_user_full_name}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Cargo que desempeña: ${survey.answers.PL01_user_position}`, 14, yPositionAmount)
            //
            doc.setFontSize(14)
            doc.setFontType("bold");
            yPositionAmount += 12
            doc.text(`III- DEL SERVICIO DE ASISTENCIA TÉCNICA:`, 14, yPositionAmount)
            doc.setFontSize(12)
            doc.setFontType("normal")
            var PL01ToImprove = ""
            survey.answers.PL01_to_improve.forEach((improve, index) => {
                if(index < (survey.answers.PL01_to_improve.length - 1)) {
                    PL01ToImprove = `${PL01ToImprove} ${improve},`
                } else {
                    PL01ToImprove = `${PL01ToImprove} ${improve}`
                }
            });
            yPositionAmount += 7
            doc.text(`¿Respecto al(los) Servicios de Asistencia Técnica prestados,`, 14, yPositionAmount)
            yPositionAmount += 5
            doc.text(`en que aspectos sugiere trabajar para mejorarlos?`, 16, yPositionAmount)
            yPositionAmount += 6
            doc.text(`${PL01ToImprove}`, 18, yPositionAmount)
            doc.setFontSize(10)
            var textWidthTitleTable = doc.getStringUnitWidth(`A su buen criterio, indique la calificación que corresponda para cada aspecto del servicio que se le presta`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitleTable = (doc.internal.pageSize.width - textWidthTitleTable) / 2;
            yPositionAmount += 8
            doc.text(textOffsetTitleTable, yPositionAmount, `A su buen criterio, indique la calificación que corresponda para cada aspecto del servicio que se le presta`);
            var textWidthTitleTableValues = doc.getStringUnitWidth(`M: Malo | R: Regular | B: Bueno | MB: Muy Bueno | E: Excelente`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitleTableValues = (doc.internal.pageSize.width - textWidthTitleTableValues) / 2;
            yPositionAmount += 6
            doc.text(textOffsetTitleTableValues, yPositionAmount, `M: Malo | R: Regular | B: Bueno | MB: Muy Bueno | E: Excelente`);
            //Table
            doc.setFontSize(12)
            doc.autoTable({ html: '#my-table' })
            const dataItemTitleRowTable = [
                "Relación y trato del profesional con el prestador",
                "Preaviso de la visita del profesional a la localidad",
                "Puntualidad del profesional según corresponda",
                "Comunicación entre el profesional y el Prestador",
                "Tiempo de respuesta del profesional ante un pedido",
                "Predisposición a la resolución de problemas",
                "Cumplimiento en fecha de trabajos comprometidos",
                "Cumplimiento en forma de trabajos comprometidos",
                "Tiempo de respuesta ante requerimientos del ENTE Regulador/ Organismos Públicos",
                "Eficiencia del profesional en la capacitación del personal",
                "Eficiencia del profesional en la elaboración de notas y gestiones",
                "Cordialidad y espiritu servicial del profesional"
            ];
            const dataTable = []
            for(var i = 0; i < 12; i++) {
                const dataRow = Array(7)
                dataRow[0] = dataItemTitleRowTable[i]
                const choiseXPosition = valuesPL01Position[survey.answers[`PL01_calification_${(i+1 < 10 ? `0${(i+1)}` : `${(i+1)}`)}`]]
                dataRow[choiseXPosition] = "X"
                dataTable.push(dataRow)
            }
            yPositionAmount += 2
            doc.autoTable({
                theme: "grid",
                startY: yPositionAmount,
                head: [['ASPECTO A CALIFICAR', 'M', 'R', 'B', 'MB', 'E', 'N/A']],
                body: dataTable,
                headStyles: { halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 122 },
                    1: { halign: 'center', cellWidth: 10 },
                    2: { halign: 'center', cellWidth: 10 },
                    3: { halign: 'center', cellWidth: 10 },
                    4: { halign: 'center', cellWidth: 10 },
                    5: { halign: 'center', cellWidth: 10 },
                    6: { halign: 'center', cellWidth: 10 },
                },
            })
            yPositionAmount += 104
            doc.autoTable({
                theme: "grid",
                startY: yPositionAmount,
                body: [[`Elaborado por: Gerente Técnico`,`Aprobado por: Responsable del SGC\nVisado por: Dirección General`]],
                bodyStyles: { halign: 'left' },
            })

            doc.save(`${survey.userEmail}_ENCUESTA:${survey.surveyName}_FECHA:${survey.solvedDate}.pdf`);
        });
    }

    const downloadPL02 = survey => {
        loadImage(logo_sade_negro).then((logo) => {
            var doc = new jsPDF();
            var yPositionAmount = 0;
            doc.addImage(logo, 'PNG', 14, 8, 30, 14.43);
            //Date Solved
            doc.setFontSize(12)
            var textWidthDate = doc.getStringUnitWidth(`Fecha de realización: ${moment(survey.solvedDate, "HH:mm DD/MM/YYYY").format("DD/MM/YYYY")}`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDate = (doc.internal.pageSize.width - textWidthDate) - 14;
            yPositionAmount += 18
            doc.text(textOffsetDate, yPositionAmount, `Fecha de realización: ${moment(survey.solvedDate, "HH:mm DD/MM/YYYY").format("DD/MM/YYYY")}`);
            // title
            doc.setFontSize(18)
            var textWidthTitle = doc.getStringUnitWidth(`${survey.surveyName}`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitle = (doc.internal.pageSize.width - textWidthTitle) / 2;
            yPositionAmount += 10
            doc.text(textOffsetTitle, yPositionAmount, `${survey.surveyName}`);
            //REV. NUM
            doc.setFontSize(10)
            yPositionAmount += 6
            doc.text(`Número de revisión: 01`, 14, yPositionAmount)
            //FECHA VIGENCIA
            doc.setFontSize(10)
            var textWidthDateV = doc.getStringUnitWidth(`Fecha de vigencia: noviembre 2019`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDateV = (doc.internal.pageSize.width - textWidthDateV) / 2;
            doc.text(textOffsetDateV, yPositionAmount, `Fecha de vigencia: noviembre 2019`);
            //ID PL
            doc.setFontSize(10)
            var textWidthDate = doc.getStringUnitWidth(`PL02-PR-GGC-004`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDate = (doc.internal.pageSize.width - textWidthDate) - 14;
            doc.text(textOffsetDate, yPositionAmount, `PL02-PR-GGC-004`);
            //
            doc.setFontSize(14)
            doc.setFontType("bold");
            yPositionAmount += 12
            doc.text(`I- DATOS DEL CLIENTE:`, 14, yPositionAmount)
            doc.setFontSize(12)
            doc.setFontType("normal")
            yPositionAmount += 7
            doc.text(`Nombre de Empresa, Comuna o Cooperativa: ${survey.answers.PL02_client_name}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Localidad: ${survey.answers.PL02_client_location}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Dirección: ${survey.answers.PL02_client_direction}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`e-mail: ${survey.answers.PL02_client_email}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Actividad/Servicio: ${survey.answers.PL02_client_activity_service}`, 14, yPositionAmount)
            var PL02Types = ""
            survey.answers.PL02_types.forEach((type, index) => {
                if(index < (survey.answers.PL02_types.length - 1)) {
                    PL02Types = `${PL02Types} ${type},`
                } else {
                    PL02Types = `${PL02Types} ${type}`
                }
                if(index == 2 && (survey.answers.PL02_types.length) > 3) {
                    PL02Types = `${PL02Types}\n`
                }
            });
            yPositionAmount += 7
            doc.text(`Servicio de Consultoría contratado:`, 14, yPositionAmount)
            yPositionAmount += 6
            doc.text(`${PL02Types}`, 18, yPositionAmount)
            if(survey.answers.PL02_types.length > 3) {
                yPositionAmount += 6
            }
            //
            doc.setFontSize(14)
            doc.setFontType("bold");
            yPositionAmount += 12
            doc.text(`II- DATOS DEL ENCUESTADO:`, 14, yPositionAmount)
            doc.setFontSize(12)
            doc.setFontType("normal")
            yPositionAmount += 7
            doc.text(`Apellido y Nombre: ${survey.answers.PL02_user_full_name}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Cargo: ${survey.answers.PL02_user_position}`, 14, yPositionAmount)
            //
            doc.setFontSize(14)
            doc.setFontType("bold");
            yPositionAmount += 12
            doc.text(`III- DEL SERVICIO DE CONSULTORIA:`, 14, yPositionAmount)
            doc.setFontSize(10)
            doc.setFontType("normal")
            var textWidthTitleTable = doc.getStringUnitWidth(`A su buen criterio, indique la calificación que corresponda para cada aspecto del servicio contratado`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitleTable = (doc.internal.pageSize.width - textWidthTitleTable) / 2;
            yPositionAmount += 7
            doc.text(textOffsetTitleTable, yPositionAmount, `A su buen criterio, indique la calificación que corresponda para cada aspecto del servicio contratado`);
            var textWidthTitleTableValues = doc.getStringUnitWidth(`M: Malo | R: Regular | B: Bueno | MB: Muy Bueno | E: Excelente`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitleTableValues = (doc.internal.pageSize.width - textWidthTitleTableValues) / 2;
            yPositionAmount += 6
            doc.text(textOffsetTitleTableValues, yPositionAmount, `M: Malo | R: Regular | B: Bueno | MB: Muy Bueno | E: Excelente`);
            //Table
            doc.setFontSize(12)
            doc.autoTable({ html: '#my-table' })
            const dataItemTitleRowTable = [
                "Relación y trato del profesional con el prestador",
                "Preaviso de la visita del profesional a la localidad",
                "Comunicación entre el profesional y el Comitente",
                "Tiempo de respuesta del profesional ante un pedido",
                "Predisposición a la resolución de problemas",
                "Cumplimiento en fecha de trabajos comprometidos",
                "Cumplimiento en presentación de trabajos en papel y soporte magnético",
                "Tiempo de respuesta ante requerimientos de la Autoridad de Aplicación y/o ente revisor"
            ];
            const dataTable = []
            for(var i = 0; i < 8; i++) {
                const dataRow = Array(7)
                dataRow[0] = dataItemTitleRowTable[i]
                const choiseXPosition = valuesPL02Position[survey.answers[`PL02_calification_0${(i+1)}`]]
                dataRow[choiseXPosition] = "X"
                dataTable.push(dataRow)
            }
            yPositionAmount += 2
            doc.autoTable({
                theme: "grid",
                startY: yPositionAmount,
                head: [['ASPECTO A CALIFICAR', 'M', 'R', 'B', 'MB', 'E', 'N/A']],
                body: dataTable,
                headStyles: { halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 122 },
                    1: { halign: 'center', cellWidth: 10 },
                    2: { halign: 'center', cellWidth: 10 },
                    3: { halign: 'center', cellWidth: 10 },
                    4: { halign: 'center', cellWidth: 10 },
                    5: { halign: 'center', cellWidth: 10 },
                    6: { halign: 'center', cellWidth: 10 },
                },
            })
            yPositionAmount += 74
            doc.autoTable({
                theme: "grid",
                startY: yPositionAmount,
                body: [[`Elaborado por: Dirección General`,`Aprobado por: Responsable del SGC\nVisado por: Dirección General`]],
                bodyStyles: { halign: 'left' },
            })

            doc.save(`${survey.userEmail}_ENCUESTA:${survey.surveyName}_FECHA:${survey.solvedDate}.pdf`);
        });
    }

    const downloadPL03 = survey => {
        loadImage(logo_sade_negro).then((logo) => {
            var doc = new jsPDF();
            var yPositionAmount = 0;
            doc.addImage(logo, 'PNG', 14, 8, 30, 14.43);
            //Date Solved
            doc.setFontSize(12)
            var textWidthDate = doc.getStringUnitWidth(`Fecha de realización: ${moment(survey.solvedDate, "HH:mm DD/MM/YYYY").format("DD/MM/YYYY")}`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDate = (doc.internal.pageSize.width - textWidthDate) - 14;
            yPositionAmount += 18
            doc.text(textOffsetDate, yPositionAmount, `Fecha de realización: ${moment(survey.solvedDate, "HH:mm DD/MM/YYYY").format("DD/MM/YYYY")}`);
            // title
            doc.setFontSize(18)
            var textWidthTitle = doc.getStringUnitWidth(`${survey.surveyName}`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitle = (doc.internal.pageSize.width - textWidthTitle) / 2;
            yPositionAmount += 10
            doc.text(textOffsetTitle, yPositionAmount, `${survey.surveyName}`);
            //REV. NUM
            doc.setFontSize(10)
            yPositionAmount += 6
            doc.text(`Número de revisión: 00`, 14, yPositionAmount)
            //FECHA VIGENCIA
            doc.setFontSize(10)
            var textWidthDateV = doc.getStringUnitWidth(`Fecha de vigencia: abril 2018`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDateV = (doc.internal.pageSize.width - textWidthDateV) / 2;
            doc.text(textOffsetDateV, yPositionAmount, `Fecha de vigencia: abril 2018`);
            //ID PL
            doc.setFontSize(10)
            var textWidthDate = doc.getStringUnitWidth(`PL03-PR-GGC-004`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDate = (doc.internal.pageSize.width - textWidthDate) - 14;
            doc.text(textOffsetDate, yPositionAmount, `PL03-PR-GGC-004`);
            //
            doc.setFontSize(12)
            doc.setFontType("normal")
            yPositionAmount += 12
            doc.text(`Servicio realizado: ${survey.answers.PL03_service_performed}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Cliente: ${survey.answers.PL03_client}`, 14, yPositionAmount)
            yPositionAmount += 7
            doc.text(`Cargo dentro de la institución/empresa: ${survey.answers.PL03_position}`, 14, yPositionAmount)
            //
            yPositionAmount += 12
            doc.setFontSize(10)
            var textWidthTitleTable = doc.getStringUnitWidth(`Señale con una cruz en la casilla correspondiente`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitleTable = (doc.internal.pageSize.width - textWidthTitleTable) / 2;
            doc.text(textOffsetTitleTable, yPositionAmount, `Señale con una cruz en la casilla correspondiente`);
            doc.setFontSize(8)
            var textWidthTitleTableValues = doc.getStringUnitWidth(`1: MAL (cumplimiento insatisfactorio de los requisitos) | 2: REGULAR (Cumple la mayoría de los requisitos, pero necesita mejorar)`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitleTableValues = (doc.internal.pageSize.width - textWidthTitleTableValues) / 2;
            yPositionAmount += 6
            doc.text(textOffsetTitleTableValues, yPositionAmount, `1: MAL (cumplimiento insatisfactorio de los requisitos) | 2: REGULAR (Cumple la mayoría de los requisitos, pero necesita mejorar)`);
            var textWidthTitleTableValues2 = doc.getStringUnitWidth(`3: BIEN (Cumple con los requisitos) | 4: MUY BIEN (Excede los requisitos)`) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetTitleTableValues2 = (doc.internal.pageSize.width - textWidthTitleTableValues2) / 2;
            yPositionAmount += 6
            doc.text(textOffsetTitleTableValues2, yPositionAmount, `3: BIEN (Cumple con los requisitos) | 4: MUY BIEN (Excede los requisitos)`);
            //Table
            doc.setFontSize(12)
            doc.autoTable({ html: '#my-table' })
            yPositionAmount += 2
            doc.autoTable({
                theme: "plain",
                startY: yPositionAmount,
                head: [["A.  PRESTACIÓN DEL SERVICIO"]],
                headStyles: { halign: 'center' },
                columnStyles: {
                    0: { cellWidth: 182 },
                },
            })
            const dataItemTitleRowTable = [
                "Presencia",
                "Puntualidad",
                "Trato personal",
                "Claridad en las explicaciones",
                "¿Cómo califica el soporte técnico recibido?",
                "S&D cumple con los plazos de entrega de informes y/o resultados",
                "S&D brinda respuesta adecuada a sus consultas técnicas",
                "¿Cómo califica el cumplimiento de las expectativas que tenía al solicitar el servicio?",
            ];
            var dataTable = []
            for(var i = 0; i < 8; i++) {
                const dataRow = Array(5)
                dataRow[0] = dataItemTitleRowTable[i]
                const choiseXPosition = survey.answers[`PL03_calification_0${(i+1)}`]
                dataRow[choiseXPosition] = "X"
                dataTable.push(dataRow)
            }
            yPositionAmount += 7
            doc.autoTable({
                theme: "grid",
                startY: yPositionAmount,
                head: [['ASPECTO A EVALUAR', '1', '2', '3', '4']],
                body: dataTable,
                headStyles: { halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 134 },
                    1: { halign: 'center', cellWidth: 12 },
                    2: { halign: 'center', cellWidth: 12 },
                    3: { halign: 'center', cellWidth: 12 },
                    4: { halign: 'center', cellWidth: 12 },
                },
            })
            //
            yPositionAmount += 70
            doc.autoTable({
                theme: "plain",
                startY: yPositionAmount,
                head: [["B.  OFERTA"]],
                headStyles: { halign: 'center' },
                columnStyles: {
                    0: { cellWidth: 182 },
                },
            })
            var dataRow = Array(5)
            dataRow[0] = "En general, la oferta se ajusta al servicio prestado"
            var choiseXPosition = survey.answers[`PL03_calification_09`]
            dataRow[choiseXPosition] = "X"
            yPositionAmount += 7
            doc.autoTable({
                theme: "grid",
                startY: yPositionAmount,
                head: [['ASPECTO A EVALUAR', '1', '2', '3', '4']],
                body: [dataRow],
                headStyles: { halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 134 },
                    1: { halign: 'center', cellWidth: 12 },
                    2: { halign: 'center', cellWidth: 12 },
                    3: { halign: 'center', cellWidth: 12 },
                    4: { halign: 'center', cellWidth: 12 },
                },
            })
            //
            yPositionAmount += 18
            doc.autoTable({
                theme: "plain",
                startY: yPositionAmount,
                head: [["C.  OTROS"]],
                headStyles: { halign: 'center' },
                columnStyles: {
                    0: { cellWidth: 182 },
                },
            })
            var PL03_10 = ""
            survey.answers.PL03_calification_10.forEach((type, index) => {
                if(index < (survey.answers.PL03_calification_10.length - 1)) {
                    PL03_10 = `${PL03_10} ${type},`
                } else {
                    PL03_10 = `${PL03_10} ${type}`
                }
            });
            yPositionAmount += 7
            doc.text(`¿Cómo nos conoció?`, 14, yPositionAmount)
            yPositionAmount += 6
            doc.text(`${PL03_10}`, 18, yPositionAmount)
            dataRow = Array(5)
            dataRow[0] = "¿Cuál es su evaluación respecto de la comunicación?"
            choiseXPosition = survey.answers[`PL03_calification_11`]
            dataRow[choiseXPosition] = "X"
            yPositionAmount += 7
            doc.autoTable({
                theme: "grid",
                startY: yPositionAmount,
                head: [['ASPECTO A EVALUAR', '1', '2', '3', '4']],
                body: [dataRow],
                headStyles: { halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 134 },
                    1: { halign: 'center', cellWidth: 12 },
                    2: { halign: 'center', cellWidth: 12 },
                    3: { halign: 'center', cellWidth: 12 },
                    4: { halign: 'center', cellWidth: 12 },
                },
            })
            //
            yPositionAmount += 18
            doc.autoTable({
                theme: "plain",
                startY: yPositionAmount,
                head: [["D.  INDIQUE PORQUE ELIJE/ NOS SIGUE ELIGIENDO"]],
                headStyles: { halign: 'center' },
                columnStyles: {
                    0: { cellWidth: 182 },
                },
            })
            var PL03_12 = ""
            survey.answers.PL03_calification_12.forEach((type, index) => {
                if(index < (survey.answers.PL03_calification_12.length - 1)) {
                    PL03_12 = `${PL03_12} ${type},`
                } else {
                    PL03_12 = `${PL03_12} ${type}`
                }
                if(index == 3 && (survey.answers.PL03_calification_12.length) > 4) {
                    PL03_12 = `${PL03_12}\n`
                }
            });
            yPositionAmount += 10
            doc.text(`${PL03_12}`, 14, yPositionAmount)
            if(survey.answers.PL03_calification_12.length > 4) {
                yPositionAmount += 6
            }
            yPositionAmount += 7
            doc.text(`Sugerencias/ comentarios respecto al servicio brindado:`, 14, yPositionAmount)
            yPositionAmount += 6
            var suggestions = doc.splitTextToSize(survey.answers.PL03_calification_13, 180)
            doc.text(suggestions, 14, yPositionAmount)

            doc.save(`${survey.userEmail}_ENCUESTA:${survey.surveyName}_FECHA:${survey.solvedDate}.pdf`);
        });
    }

    return (
        <Table className="surveysSolvedTableCont" dataSource={data} rowKey="id" size="small" pagination={true} scroll={{x: 1200}}>
            <Column className="surveyNameCont" title="Encuesta" dataIndex="surveyName" key="surveyName" align="center" width="20%"
            filters={surveyNameFilters} onFilter={(value, record) => record.surveyName.indexOf(value) === 0}/>
            <Column className="emailCont" title="Correo" dataIndex="userEmail" key="userEmail" align="center" width="35%"/>
            <Column className="assignedDateCont" title="Fecha de asignación" dataIndex="assignedDate" key="assignedDate" align="center" width="20%"/>
            <Column className="solvedDateCont" title="Fecha de realización" dataIndex="solvedDate" key="solvedDate" align="center" width="20%"/>
            <Column className="downloadCont" title="Descargar" dataIndex="id" key="id" align="center" width="5%"
            render={(text, record) => {
                return(
                    <Tooltip title="Descargar pdf">
                        <Button onClick={() => onDownloadSurvey(record)} icon={<DownloadOutlined />} />
                    </Tooltip>
                );
            }}/>
        </Table>
    );
};

SurveysSolvedTable.propTypes = {
    data: PropTypes.array,
};

export default SurveysSolvedTable;
